import React from "react";

import styles from "./Cards.module.scss";
import PreviousPage from "../../../partials/PreviousPage/PreviousPage";
import { formatPrice } from "../../../../utils/formatPrice";

const Cards: React.FC = () => {
  return (
    <section className={styles.cards}>
      <div className="container">
        <PreviousPage currentPage="Подарочные сертификаты" title="Подарочные сертификаты" />
        <div className={styles.info}>
          <p>Нужный и необычный подарок для ценителей и профессионалов</p>
        </div>
        <div className={styles.body}>
          <div className={styles.item}>
            <div className={styles.image}>
              <img src="#" alt="gift-card" />
            </div>
            <h3>Сертификат</h3>
            <p className={styles.price}>{formatPrice(1000)}</p>
            <div className={styles.buy}>
              <button>Купить</button>
            </div>
          </div>
          <div className={styles.item}>
            <div className={styles.image}>
              <img src="#" alt="gift-card" />
            </div>
            <h3>Сертификат</h3>
            <p className={styles.price}>{formatPrice(3000)}</p>
            <div className={styles.buy}>
              <button>Купить</button>
            </div>
          </div>
          <div className={styles.item}>
            <div className={styles.image}>
              <img src="#" alt="gift-card" />
            </div>
            <h3>Сертификат</h3>
            <p className={styles.price}>{formatPrice(5000)}</p>
            <div className={styles.buy}>
              <button>Купить</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Cards;
